module.exports = __webpack_public_path__ + "../static/img/suite_mini.d76da827.png";